// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;

// Pre-requisites.
// Add a Woocommerce "Cart" widget to the Mini-Cart sidebar in Wordpress Admin.


// To understand how the mini cart works you will want to view these files in Woocommerce to see the events that fire:
//
// /woocommerce/assets/js/frontend/cart-fragments.js
// /woocommerce/assets/js/frontend/add-to-cart.js
// /woocommerce/assets/js/frontend/cart.js (this is the full cart js, but it might serve as reference)

// You will also want to check out the html structure:
// /woocommerce/templates/cart/mini-cart.php
// /themes/emopress/inc/woocommerce-customisations.php (this is where it gets initialised)


// TODO: Improvements:
// - Test cart with wishlist to make sure no bugs arise
// - Use the jquery.blockUI plugin that is bundled with woocommerce?



const settings = {
    isOpenClass: 'is-open-mini-cart',
    isLoadingClass: 'is-loading',
    siteToggleCartSelector: '.js-header-cart-link, .js-mini-cart-close, .js-mini-cart-overlay', // jquery selector (string), separate with a ", " all the selectors that should toggle the cart.
    miniCartContainerSelector: '.mini-cart', // the container for the mini cart.
    openCartAfterAddedToCart: true,
};









// Our interactions with woocommerce ajax all goes through here.
import WooAPI from './api.js';





export default class MiniCart {

    // Starts here.
    constructor(options) {
        this.setInitialState();
        this.setCache(options);
        this.bindEvents();
    }


    // set a state object (for checking different states the mini-cart might have)
    setInitialState() {
        this.state = {
            isOpen: false,
            isLoading: false,
        };
    }

    // cache DOM elements when possible for performance
    setCache () {
        this.cache = {};
        this.cache.container = $(settings.miniCartContainerSelector);

        // stop if the mini-cart doesn't even exist
        if (this.cache.container.length) {
            this.cache.body = $(document.body); // lots of woocommerce events get fired here.
        }
    }


    // bind the different events that interact with the component
    bindEvents () {

        // no use binding if doesn't exist
        if (this.cache.container.length) {

            // ajaxify the remove item links in mini cart
            this.cache.container.on('click', '.remove', this.removeItem.bind(this));

            // open mini cart if an item was added to it from somewhere on the site
            if (settings.openCartAfterAddedToCart) {
                this.cache.body.on('added_to_cart', this.openCart.bind(this));
            }

            // optionally, if you have a toggle cart link somewhere, this will activate it.
            if (settings.siteToggleCartSelector) {
                this.cache.body.on('click', settings.siteToggleCartSelector, this.toggleCart.bind(this));
            }

            // in casre your mini cart has inputs, watch for changes and show the update cart button.
            this.cache.container.on('change', 'input', this.showUpdateCartButton.bind(this));

            this.cache.body.on('click', '.single_add_to_cart_button', this.addItem.bind(this));


            this.cache.body.on('submit', '.tribe_events form', this.addBookingItem.bind(this));
        }

    }

    // ajaxify the remove item links
    removeItem(event) {
        event.preventDefault();


        var url = $( event.currentTarget ).attr('href');

        this.blockUI();

        WooAPI.removeItem(url).then( () => {
            // removing from cart succeeded.
            this.cache.body.trigger('wc_fragment_refresh'); // woocommerce takes care of all the fragment refresh logic.
            // we listen for the refresh to be complete, and unblock the UI.
            this.cache.body.one('wc_fragments_refreshed', () => {
                this.unblockUI();
            });

        }, () => {
            // removing from cart failed.
            this.cache.body.trigger('error'); // let this be handled by our global error handler.
            this.unblockUI();

        });
    }


    // TODO: This still has bugs related to messages and stock levels.
    addItem(event) {

        event.preventDefault();



        // our button
        var button = $(event.currentTarget);

        // disabled buttons don't work
        if( button.hasClass('disabled') ) {
            return;
        }

        button.removeClass( 'added' );
        button.addClass( 'loading' );

        // our form
        var form = button.closest('form');

        // the form data
        var data = form.serializeArray();

        // the below lines are a fix for a bug in serializeArray where it is not grabbign the add to cart value.
        var noAddToCart = true;

        data.forEach(function(item) {
            if (item.name == "add-to-cart") {
                noAddToCart = false;
            }
        });

        if (noAddToCart) {
            data.push({ name: "add-to-cart", value: form.find(".single_add_to_cart_button").val() });
        }


        // trigger our adding to cart listener
        this.cache.body.trigger('adding_to_cart');

        WooAPI.addItem(data).then( (response) => {
            this.cache.body.trigger('added_to_cart', [response.fragments, response.cart_hash, button]);
            //this.cache.body.trigger('wc_fragment_refresh');

            this.cache.body.one('wc_fragments_refreshed', () => {
                button.removeClass( 'loading' );
                button.addClass( 'added' );
                this.cache.body.trigger('added_to_cart');
                this.unblockUI();
            });
        }, (response) => {
            console.log(response);
            button.removeClass( 'loading' );
            this.cache.body.trigger('error');
            // modal("Error", response.responseText);
            this.unblockUI();
        } );

    }

    addBookingItem(e) {
        var $form = $(e.target).closest('form');

        if ($form.find('.woocommerce.add-to-cart').length) {

            if (window.tribe_event_tickets_plus) {

                e.preventDefault();

                if ( ! tribe_event_tickets_plus.meta.validate_submission() ) {

                    $form.addClass( 'tribe-event-tickets-plus-meta-missing-required' );

                    $( 'html, body').animate({
                        scrollTop: $form.offset().top
                    }, 300 );
                    return;
                } else {
                    e.preventDefault();

                    var button = $form.find('.woocommerce.add-to-cart .button');

                    // disabled buttons don't work
                    if( button.hasClass('disabled') ) {
                        return;
                    }

                    // our form data
                    var data = $form.serializeArray();

                    data.push({
                        name: "wootickets_process",
                        value: "1"
                    });

                    // check if the user has added quantity to anything.
                    var has_quantity = false;

                    data.forEach((item) => {
                        if (item.name.startsWith('quantity') && (+item.value)) {
                            has_quantity = true;
                        }
                    });

                    if (! has_quantity) {
                        alert("Please select a ticket");
                        return;
                    }

                    button.removeClass( 'added' );
                    button.addClass( 'loading' );


                    // trigger our adding to cart listener
                    this.cache.body.trigger('adding_to_cart');

                    WooAPI.addItem(data).then( () => {
                        this.cache.body.trigger('wc_fragment_refresh');

                        this.cache.body.one('wc_fragments_refreshed', () => {
                            button.removeClass( 'loading' );
                            button.addClass( 'added' );
                            this.cache.body.trigger('added_to_cart');
                            this.unblockUI();
                        });
                    }, (response) => {
                        console.log(response);
                        button.removeClass( 'loading' );
                        this.cache.body.trigger('error');
                        // modal("Error", response.responseText);
                        this.unblockUI();
                    } );

                }
            }
        }
    }

    // alias for toggleCart, but always true.
    openCart() {
        this.toggleCart(true);
    }

    // alias for toggleCart, but always false.
    closeCart() {
        this.toggleCart(false);
    }

    // open/close the cart.
    toggleCart (value) {

        if ("boolean" !== (typeof(value))) {
            // if an event is passed in instead of a boolean, it will prevent default and try to get a data value from the event.
            if (value.target) {
                var event = value;
                event.preventDefault();
                value = event.data;
            }

            // if you didn't pass in a boolean with the event, it will check the Mini Carts current state and toggle it.
            if ("boolean" !== (typeof(value))) {
                value = !this.state.isOpen;
            }
        }

        this.cache.body.toggleClass(settings.isOpenClass, value);

        // update a boolean on this object so that we can check the state if needed.
        this.state.isOpen = value;
    }

    // block the UI in some way so the user can't do anything else.
    blockUI() {
        this.cache.container.addClass(settings.isLoadingClass);
        this.state.isLoading = true;
    }

    // unblock the UI
    unblockUI() {
        this.cache.container.removeClass(settings.isLoadingClass);
        this.state.isLoading = false;
    }

    // If the cart has form data that needs updating, this will toggle the buttons so the the checkout button is a submit.
    // these elements aren't cached because they get destroyed on cart refresh.
    showUpdateCartButton() {
        this.cache.container.find('.js-btn-mini-cart-go-to-checkout').hide();
        this.cache.container.find('.js-btn-mini-cart-update-and-checkout').show();
    }

}
